import React, { useState } from "react";
import {
  Box,
  Flex,
  Icon,
  Tab,
  Tabs,
  TabList,
  TabPanels,
  TabPanel,
  Text,
  Button,
  Input,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from "@chakra-ui/react";
import { Users, CarTaxiFront, HandCoins, Users2, Coins, Wrench, TrendingUp, TicketPercent, ChartNetwork } from "lucide-react";
import BackgroundImage from "../../../assets/img/longarrow.jpg";
import AgentManagement from "../AgentManagement";
import StarterKitComponentsTab from "../StarterKitsComponents";
import StarterKitPurchaseManagement from "../StarterKitPurchases";
import AgentServiceManagement from "../AgentServicesManagement";
import AgentProgressionConfiguration from "../AgentProgressionManagement";
import AgentCommissionConfiguration from "../AgentCommissionConfigurations";
import AgentAnalytics from "../AgentAnalytics";

// Custom Tab Component
const CustomTab = ({ icon, label }) => (
  <Tab
    fontSize="sm"
    color="gray.500"
    _selected={{
      color: "white",
      bg: "transparent",
      backgroundImage: `url(${BackgroundImage})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
    }}
  >
    <Icon as={icon} mr={2} />
    {label}
  </Tab>
);

const AgentTabs = () => {
  return (
    <Box w="100%" p={4} mt={"70px"} ml={"9px"}>

      <Tabs variant="enclosed">
        <TabList>
          <CustomTab icon={Users2} label="Agents" />
          <CustomTab icon={CarTaxiFront} label="Starter Kits Components" />
          <CustomTab icon={Coins} label="Starter Kits Purchases" />
          <CustomTab icon={Wrench} label="Services Management" />
          <CustomTab icon={TrendingUp} label="Progression Configurations" />
          <CustomTab icon={TicketPercent} label="Commission Configurations" />
          <CustomTab icon={ChartNetwork} label="Analytics" />
        </TabList>

        <TabPanels>
          <TabPanel>
            <AgentManagement />
          </TabPanel>
          <TabPanel>
            <StarterKitComponentsTab />
          </TabPanel>
            <TabPanel>
            <StarterKitPurchaseManagement />
          </TabPanel>
           <TabPanel>
            <AgentServiceManagement />
          </TabPanel>
           <TabPanel>
            <AgentProgressionConfiguration />
          </TabPanel>
            <TabPanel>
            <AgentCommissionConfiguration />
          </TabPanel>
          <TabPanel>
            <AgentAnalytics />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};


export default AgentTabs;
